import { apiUrl, fetchJson } from '../../apiBase';

const schoolInfoCache = new Map();

export async function getSchoolInfoCached(schoolId, { force = false } = {}) {
  const key = String(schoolId || '').trim();
  if (!key) {
    return null;
  }

  if (!force && schoolInfoCache.has(key)) {
    return schoolInfoCache.get(key);
  }

  const res = await fetchJson(apiUrl(`/admin/school-info/${encodeURIComponent(key)}`));
  if (!res.ok) {
    throw new Error('school_info_load_failed');
  }
  const data = await res.json();
  schoolInfoCache.set(key, data || {});
  return data || {};
}

export function clearSchoolInfoCache(schoolId) {
  const key = String(schoolId || '').trim();
  if (!key) {
    return;
  }
  schoolInfoCache.delete(key);
}
